var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "visual" }, [
      _c("img", {
        staticClass: "d-md-none",
        attrs: { src: _vm.visual.mobileSrc, alt: "" },
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "d-none d-md-block",
        attrs: { src: _vm.visual.desktopSrc, alt: "" },
      }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "bloc-text",
        class: _vm.isSoshShop ? "bg-gray2" : "bg-dark",
      },
      [
        _c(
          "div",
          {
            staticClass: "inside-bloc-text text-center p-2",
            class: _vm.isSoshShop ? "" : "text-white",
          },
          [
            _vm.text
              ? _c("p", {
                  staticClass: "h3 mb-0",
                  domProps: { innerHTML: _vm._s(_vm.text) },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("h2", { staticClass: "h3 mb-0" }, [
              _c("span", { domProps: { innerHTML: _vm._s(_vm.subtitle) } }),
              _vm._v(" "),
              _vm.recoveryDeviceModel && _vm.recoveryAmountInCents > 0
                ? _c("span", { staticClass: "text-primary" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.recoveryDeviceModel) +
                        "\n                    "
                    ),
                    !_vm.manualEstimation
                      ? _c("span", [_vm._v(" " + _vm._s(" ?"))])
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.advantages
              ? [
                  _c("p", { staticClass: "py-0 mb-0" }, [
                    _c("strong", {
                      staticClass: "icon-rewards me-1 font-size-34",
                      class: _vm.isSoshShop ? "text-primary" : "",
                    }),
                    _c("strong", {
                      staticClass: "font-size-40",
                      domProps: { innerHTML: _vm._s(_vm.advantages) },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "small mb-0 pt-0" }, [
                    _c("small", { staticClass: "ps-3" }, [
                      _vm._v(_vm._s(_vm.messages.recoveryText)),
                    ]),
                    _vm._v(" "),
                    _vm.bonusAmountInCents > 0
                      ? _c("small", { staticClass: "ps-4" }, [
                          _vm._v(_vm._s(_vm.messages.bonusText)),
                        ])
                      : _vm._e(),
                  ]),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.bonusRecoverySelectorLink && _vm.bonusRecoverySelectorLinkLabel
              ? _c(
                  "div",
                  { staticClass: "px-lg-4 px-xl-5" },
                  [
                    _c("ob1-boutons", {
                      staticClass: "mt-1",
                      attrs: {
                        "is-button": false,
                        "is-inverse": true,
                        "is-wide": "",
                        href: _vm.bonusRecoverySelectorLink,
                        "is-secondary": true,
                        target: "_blank",
                        label: _vm.bonusRecoverySelectorLinkLabel,
                        "data-oevent-label": "vers_selecteur_avec_filtre_bonus",
                        "data-oevent-category": "ajout_bonus_reprise",
                        "data-oevent-action": "decouvrir_notre_selection",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("ob1-liens", {
                          staticClass: "mt-1 d-inline",
                          class: _vm.isSoshShop ? "" : "text-white",
                          attrs: {
                            "is-button": "",
                            "with-arrow": true,
                            "modal-id": _vm.recoveryModalId,
                            text: _vm.messages.ctaLabel,
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#" + _vm.simulatorModalId,
                            "data-oevent-label": "vers_simulateur",
                            "data-oevent-category": "Banniere_reprise_mobile",
                            "data-oevent-action": "j_accede_au_simulateur",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : [
                  _c("ob1-boutons", {
                    staticClass: "mt-1",
                    attrs: {
                      "is-secondary": true,
                      "is-inverse": true,
                      label: _vm.messages.ctaLabel,
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#" + _vm.simulatorModalId,
                      "data-oevent-label": "vers_simulateur",
                      "data-oevent-category": "Banniere_reprise_mobile",
                      "data-oevent-action": "j_accede_au_simulateur",
                    },
                  }),
                  _vm._v(" "),
                  _vm.recoveryModalId
                    ? _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _c("ob1-liens", {
                            staticClass: "mt-1 d-inline",
                            class: _vm.isSoshShop ? "" : "text-white",
                            attrs: {
                              "is-button": "",
                              "with-arrow": true,
                              "modal-id": _vm.recoveryModalId,
                              "data-bs-toggle": "modal",
                              text: _vm.messages.linkLabel,
                              "data-oevent-label": "vers_popin_reprise",
                              "data-oevent-category": "Banniere_reprise_mobile",
                              "data-oevent-action":
                                "tout_savoir_sur_la_reprise",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }